// extracted by mini-css-extract-plugin
export default {"popupTitle":"LoginMultifactorAuthenticationPopup_popupTitle__wpcXq","footerContainer":"LoginMultifactorAuthenticationPopup_footerContainer__gVR+d"};